// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Fg2u","selects":"Documents_selects__1NhRM"};